import Link from 'next/link'
import * as React from 'react'

import { TEMPLATE_DEFAULT_URLS } from '@/configs/template-default-urls'

interface NonFsdsLpCtaSectionProps {
  title: string
  description: string
  buttonText: string
  buttonUrl?: string
}

export default function NonFsdsLpCtaSection({
  title,
  description,
  buttonText,
  buttonUrl = TEMPLATE_DEFAULT_URLS.myCourses,
}: NonFsdsLpCtaSectionProps) {
  return (
    <section data-testid="non-fsds-lp-cta-section" className="px-4 py-8 sm:px-6 sm:py-10 lg:py-12">
      <div className="relative mx-auto max-w-5xl overflow-hidden rounded-3xl bg-gradient-to-r from-blue-600 via-blue-700 to-blue-800 px-6 py-14 text-center shadow-xl shadow-blue-900/20 sm:px-12 sm:py-16 lg:px-16 lg:py-20">
        {/* Decorative circles */}
        <div className="pointer-events-none absolute -left-16 -top-16 size-64 rounded-full bg-white/5" />
        <div className="pointer-events-none absolute -bottom-20 -right-12 size-80 rounded-full bg-white/5" />

        <div className="relative">
          <h2 className="mx-auto max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl md:text-4xl">
            {title}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-blue-100 sm:text-lg">{description}</p>
          <div className="mt-8">
            <Link
              href={buttonUrl}
              className="inline-flex min-h-12 cursor-pointer items-center justify-center rounded-full bg-white px-8 py-3.5 text-base font-bold text-blue-700 shadow-lg transition-all duration-200 hover:bg-blue-50 hover:shadow-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-blue-700"
            >
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
